import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showModal } from '../actions/modal'

import poster from '../images/event_poster.jpg'

import {
  Link,
  NavLink,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'

const Stats = ({ camps }) => {
  const reducer = (accumulator, currentValue) => accumulator + currentValue;
  const mapper = item => item.stats.impressions;

  const types = camps.map(campaign => campaign.type);
  const mediums = Array.from(new Set(types));
  
  const campaigns = mediums.map((medium, i) => {
    const total = camps
      .filter(item => item.type === medium)
      .map(mapper)
      .reduce(reducer);

    return (
      <div className="camp__stat" key={i}>
        <div className="camp__digit">{total}</div>
        <div className="camp__label">{medium}</div>
      </div>
    )
  });

  return (
    <div className="camp__stats">
      { campaigns }
    </div>
  )
}

const Event = ({
  name,
  preview,
  datetime,
  camps,
}) => {
  return (
    <div className="camp camp--event">
      <div className="camp__preview camp__preview--event">
        <img className="camp__img" src={ preview || poster } alt=""/>
      </div>
      <div className="camp__descr">
        <div className="camp__event">
          <div className="camp__event-block">{ name }</div><br/>
          <div className="camp__event-block">{ datetime }</div>
        </div>
        { camps.length > 0 && <Stats camps={camps} /> }
      </div>
    </div>
  )
}


class EventsPage extends Component {
  
  render() {
    const { match } = this.props;
    const { events, campaigns } = this.props;
    
    return (
      <div className="container content">
        <h2>Events</h2>
        <div className="camps">
          {
            events.map((props, i) => {
              const camps = campaigns.filter(item => item.eventId == props.id);
              return (
                <Link className="camp__link" to={`/event/${props.id}`} key={i}>
                  <Event {...props} camps={camps} />
                </Link>
              )
            })
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { events: state.events, campaigns: state.campaigns.active }
}

export default connect(mapStateToProps)(EventsPage)


// WEBPACK FOOTER //
// ./src/components/EventsPage.js